import {api} from '../../contexts/AuthContext';

export const classificationsApi = {
    getByBlueprint: async (params: {
        promptId: string;
        limit?: number;
        minScore?: number;
        domain?: string;
    }) => {
        const response = await api.post('/api/classifications/by-blueprint', params);
        return response.data;
    },
    /**
     * Preview the URLs a classification-mode analysis would pull. The filter
     * params mirror the analyze request one-for-one (bd deepcontext-4zil) so the
     * previewed list matches what the analysis actually uses; `domain` is the
     * legacy single-domain field, superseded by `classificationDomains`.
     */
    getDatabaseUrls: async (params: {
        promptId?: string;
        limit?: number;
        minScore?: number;
        domain?: string;
        classificationDomains?: string[];
        classificationCountry?: string[];
        classificationSimilaritySelectivity?: number;
        countryDistributionMode?: 'uniform' | 'proportional';
        excludeHomepages?: boolean;
    }): Promise<{urls: string[]; totalReturned: number}> => {
        const response = await api.post('/api/classifications/database-urls', params);
        return response.data;
    },
    matchUrls: async (params: {
        urls: string[];
        promptId: string;
    }): Promise<{
        results: any[];
        stats: {total: number; avgScore: number; byCategory: Record<string, number>; byMethod: Record<string, number>};
        blueprint: {id: string; name: string; primaryCategories: number[]; secondaryCategories: number[]};
        totalInput: number;
        totalMatched: number;
    }> => {
        const response = await api.post('/api/classifications/match-urls', params);
        return response.data;
    },
    getStats: async () => {
        const response = await api.get('/api/classifications/stats');
        return response.data;
    },
};
